let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fhpdo")).then(() => parcelRequire('b8ooq'));